
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("a8CW2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Navigation", () => $0a9ba8bbb34322b9$export$b8a61e5c71402559);
$parcel$export(module.exports, "default", () => $0a9ba8bbb34322b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lXam5 = parcelRequire("lXam5");
const $0a9ba8bbb34322b9$export$b8a61e5c71402559 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXam5.NavigationJourney), null));
var $0a9ba8bbb34322b9$export$2e2bcd8739ae039 = $0a9ba8bbb34322b9$export$b8a61e5c71402559;

});
parcelRegister("lXam5", function(module, exports) {

$parcel$export(module.exports, "NavigationJourney", () => $53fdcc5f48432bfa$export$1e48a6a7996903f1);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8zOmE = parcelRequire("8zOmE");
var $d22NM = parcelRequire("d22NM");

var $doZTA = parcelRequire("doZTA");

var $71JPe = parcelRequire("71JPe");
const $53fdcc5f48432bfa$var$getInitialStateFromSession = (host)=>{
    const isNew = (0, $71JPe.isNewJourney)(host);
    const { prevUrl: prevUrl, attributes: attributes } = (0, $71JPe.restoreFromSession)(isNew) || {};
    return {
        prevUrl: prevUrl,
        attributes: {
            steps: 0,
            prevPage: null,
            isPrevPageSpa: null,
            currentPage: null,
            isCurrentPageSpa: null,
            ...attributes,
            isInitial: true,
            isNew: isNew
        }
    };
};
const $53fdcc5f48432bfa$var$debouncedChange = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(({ navJourneyState: navJourneyState, location: location, route: route, createAnalyticsEvent: createAnalyticsEvent, setNavJourneyState: setNavJourneyState })=>{
    const { prevUrl: prevUrl, attributes: attributes } = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    navJourneyState || $53fdcc5f48432bfa$var$getInitialStateFromSession(window.location.host);
    const currentUrl = (0, $71JPe.cleanUrl)(location.pathname, location.search);
    const currentPage = route?.name;
    if (route?.isRedirect === true) return;
    if (currentUrl === null || currentPage == null || prevUrl === currentUrl // refresh page
    ) return;
    const newAttributes = {
        ...attributes,
        prevPage: attributes?.currentPage,
        isPrevPageSpa: attributes?.isCurrentPageSpa,
        currentPage: currentPage,
        isCurrentPageSpa: __SPA__
    };
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'NavigationJourney navigated', newAttributes);
    newAttributes.steps += 1;
    newAttributes.isInitial = false;
    newAttributes.isNew = false;
    const newState = {
        prevUrl: currentUrl,
        attributes: newAttributes
    };
    setNavJourneyState(newState);
    (0, $71JPe.saveToSession)(newState);
}, 1000);
const $53fdcc5f48432bfa$export$1e48a6a7996903f1 = ()=>{
    const [navJourneyState, setNavJourneyState] = (0, $5uXOq.useState)(null);
    const [{ location: location, route: route }] = (0, $doZTA.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>$53fdcc5f48432bfa$var$debouncedChange({
            navJourneyState: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'State | null'.
            navJourneyState,
            location: location,
            route: route,
            createAnalyticsEvent: createAnalyticsEvent,
            setNavJourneyState: setNavJourneyState
        }), [
        location,
        navJourneyState,
        route,
        createAnalyticsEvent,
        setNavJourneyState
    ]);
    return null;
};

});
parcelRegister("71JPe", function(module, exports) {

$parcel$export(module.exports, "isNewJourney", () => $1cea7609778164cf$export$cba1f44b1e2c915c);
$parcel$export(module.exports, "restoreFromSession", () => $1cea7609778164cf$export$e59f5ef7117129a1);
$parcel$export(module.exports, "saveToSession", () => $1cea7609778164cf$export$15a2109d39af6362);
$parcel$export(module.exports, "cleanUrl", () => $1cea7609778164cf$export$39cd5310d932e557);

var $8QpSo = parcelRequire("8QpSo");

var $ebyGx = parcelRequire("ebyGx");

var $eNf8a = parcelRequire("eNf8a");
const $1cea7609778164cf$var$SESSION_KEY = 'navigation-journey';
const $1cea7609778164cf$var$RELEVANT_PARAMS = [
    'filter',
    'selectedItem',
    'rapidView',
    'view',
    'selectPageId',
    'chart'
];
const $1cea7609778164cf$var$storage = (0, $8QpSo.default)(()=>(0, $eNf8a.createSessionStorageProvider)('page-container'));
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $1cea7609778164cf$var$getReferrer = ()=>document ? document.referrer : '';
const $1cea7609778164cf$export$cba1f44b1e2c915c = (host)=>{
    const isComingFromSameHost = $1cea7609778164cf$var$getReferrer().includes(host);
    // three situation where isComingFromSameHost will be false:
    // 1. the url change is from spa transition, document.referrer = '',
    // But in this case, we get the state from navJourneyState, this code will not run
    // 2. we navigate from a different host
    // 3. we enter the url directly or open the tab via bookmark, document.referrer = ''
    return !isComingFromSameHost;
};
const $1cea7609778164cf$export$e59f5ef7117129a1 = (isNew)=>{
    let journey = null;
    // protect from tab reuse
    if (isNew) return journey;
    try {
        journey = JSON.parse($1cea7609778164cf$var$storage().get($1cea7609778164cf$var$SESSION_KEY));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
    /* ignore */ }
    return journey;
};
const $1cea7609778164cf$export$15a2109d39af6362 = (value)=>{
    try {
        $1cea7609778164cf$var$storage().set($1cea7609778164cf$var$SESSION_KEY, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
    /* ignore */ }
};
const $1cea7609778164cf$export$39cd5310d932e557 = (pathname, params)=>{
    let url = pathname.replace(/\/$/, '');
    // ignore /browse redirects or sw classic redirects
    if (/\/browse\/\w+$/.test(pathname) || params.includes('useStoredSettings')) return null;
    // ignore PIN + issue key urls (we only care about filter)
    if (/\/projects\/\w+\/issues\/\w+-\d+/.test(pathname)) url = pathname.replace(/issues\/\w+-\d+(.*)$/, 'issues');
    url += '?';
    if (params) {
        const paramsObj = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(params);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const validParams = Object.keys(paramsObj).reduce((acc, pk)=>{
            if ($1cea7609778164cf$var$RELEVANT_PARAMS.includes(pk)) acc[pk] = paramsObj[pk];
            return acc;
        }, {});
        // ignore GIN issue key change (we only care about filter/jql)
        if (paramsObj.filter || paramsObj.jql) url = url.replace(/^\/issues\?$|^\/browse\/\w+-\d+(.*)$/, '/browse/ISSUE-1?');
        url += (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(validParams);
    }
    return url;
};

});




//# sourceMappingURL=async-global-navigation-components.b7c4fd2d.js.map
